import cloneDeep from 'lodash.clonedeep';
import { CREATE_NEW_CUSTOMER_ORDER_SUCCESS, UPGRADE_EXISTING_ACCOUNT_SUCCESS } from 'JS/actionCreators/paymentActions';

import {
  UPDATE_SCRIBE,
  SET_ACTIVE_SCRIBE,
  SET_ACTIVE_ELEMENTS,
  ADD_SCRIBE_SUCCESS,
  LOAD_SCRIBES,
  LOAD_SCRIBES_SUCCESS,
  DELETE_SCRIBE_SUCCESS,
  SORT_SCRIBES,
  ADD_TO_ACTIVE_ELEMENTS,
  LOAD_CURSORS_SUCCESS,
  PREP_SCRIBE_FOR_EDITOR_SUCCESS,
  EDITOR_CLOSE,
  CREATE_SCENE,
  SET_SELECTED_SCENES,
  SET_ACTIVE_SCENE,
  UPDATE_CLIPBOARD_PAYLOAD,
  DELETE_MULTIPLE_ELEMENTS_BY_ID,
  DELETE_SELECTED_SCENES,
  SET_SHOW_ELEMENT_MODAL,
  CREATE_TEXT_ELEMENT,
  REWRITE_HISTORY
} from '../actionCreators/scribeActions';
import { EDITOR_UNDO_SUCCESS, EDITOR_REDO_SUCCESS, EDITOR_SET_EDIT_PANEL_MODE } from '../actionCreators/editorActions';
import { RESET_STATE } from '../actionCreators/generalActions';
import {
  DUPLICATE_SCRIBE,
  DUPLICATE_SCRIBE_SUCCESS,
  DUPLICATE_SCRIBE_FAILED,
  DUPLICATE_SCRIBE_START
} from '../actionCreators/duplicateScribeActions';

import setActiveSceneReducer from './reducerHelpers/setActiveSceneReducer';

const initialState = {
  activeScribePast: [],
  activeScribeFuture: [],
  activeElements: [],
  showModal: null,
  loadingAllScribes: true,
  loadingScribes: [],
  allScribes: [],
  clipboard: null,
  scribesSortOrder: 'updatedDate',
  cursors: [],
  loadingScribeForEditor: true,
  selectedSceneIds: [],
  duplicatingScribe: false
};

export default function scribesReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_SCRIBE:
      action.scribe.updatedOn = new Date();

      return {
        ...state,
        allScribes: state.allScribes.map(scribe => (scribe.id === action.scribe.id ? action.scribe : scribe)),
        activeScribePast: action.skipUndoHistory
          ? state.activeScribePast
          : [...state.activeScribePast, cloneDeep(state.allScribes.find(scribe => scribe.id === action.scribe.id))],
        activeScribeFuture: action.skipUndoHistory ? state.activeScribeFuture : []
      };

    case SET_ACTIVE_SCRIBE: {
      return {
        ...state,
        // clear undo/redo history
        activeScribePast: [],
        activeScribeFuture: [],
        activeElements: [],
        loadingScribeForEditor: true
      };
    }

    case SET_ACTIVE_ELEMENTS: {
      return {
        ...state,
        activeElements: typeof action.elementIds === 'string' ? [action.elementIds] : action.elementIds
      };
    }

    case ADD_TO_ACTIVE_ELEMENTS: {
      let newActiveElements = state.activeElements.slice();
      const isMultipleElements = Array.isArray(newActiveElements);
      if (!isMultipleElements) {
        newActiveElements = [newActiveElements];
      }

      if (newActiveElements.indexOf(action.elementId) === -1) newActiveElements.push(action.elementId);

      return {
        ...state,
        activeElements: newActiveElements
      };
    }

    case RESET_STATE: {
      return {
        ...initialState
      };
    }

    case ADD_SCRIBE_SUCCESS: {
      return {
        ...state,
        allScribes: [...state.allScribes, action.scribe]
      };
    }

    case UPDATE_CLIPBOARD_PAYLOAD: {
      return {
        ...state,
        clipboard: action.payload
      };
    }

    case EDITOR_UNDO_SUCCESS:
    case EDITOR_REDO_SUCCESS: {
      return {
        ...state,
        activeScribePast: action.newPast,
        activeScribeFuture: action.newFuture,
        activeElements: []
      };
    }

    case LOAD_SCRIBES: {
      return {
        ...state,
        loadingAllScribes: true
      };
    }

    case LOAD_SCRIBES_SUCCESS: {
      return {
        ...state,
        allScribes: action.scribes,
        loadingAllScribes: false
      };
    }
    case DELETE_SCRIBE_SUCCESS: {
      const newScribes = [...state.allScribes];
      const index = newScribes.findIndex(scribe => {
        return scribe.id === action.scribeId;
      });

      if (index > -1) {
        newScribes.splice(index, 1);
      }

      return {
        ...state,
        allScribes: newScribes
      };
    }

    case SORT_SCRIBES:
      return {
        ...state,
        scribesSortOrder: action.sortOrder
      };

    case REWRITE_HISTORY:
      return {
        ...state,
        activeScribePast: action.activeScribePast,
        activeScribeFuture: action.activeScribeFuture
      };

    case LOAD_CURSORS_SUCCESS:
      return {
        ...state,
        cursors: action.cursors
      };

    case CREATE_NEW_CUSTOMER_ORDER_SUCCESS:
    case UPGRADE_EXISTING_ACCOUNT_SUCCESS: {
      const clearViewOnlyScribes = state.allScribes.map(scribe => {
        scribe.viewOnly = false;
        return scribe;
      });

      return {
        ...state,
        allScribes: clearViewOnlyScribes
      };
    }

    case PREP_SCRIBE_FOR_EDITOR_SUCCESS: {
      const replacementIndex = state.allScribes.findIndex(scribe => scribe.id === action.scribe.id);
      if (replacementIndex !== -1) {
        const updatedScribes = [...state.allScribes];
        updatedScribes[replacementIndex] = action.scribe;

        return {
          ...state,
          allScribes: updatedScribes,
          loadingScribeForEditor: false
        };
      }
      return state;
    }

    case EDITOR_CLOSE: {
      return {
        ...state,
        loadingScribeForEditor: true,
        selectedSceneIds: []
      };
    }

    case CREATE_SCENE: {
      return {
        ...state,
        activeElements: []
      };
    }

    case SET_SELECTED_SCENES: {
      return {
        ...state,
        selectedSceneIds: [...action.sceneIds],
        activeElements: []
      };
    }

    case SET_ACTIVE_SCENE: {
      return setActiveSceneReducer(state, action);
    }

    case EDITOR_SET_EDIT_PANEL_MODE: {
      if (action.mode === 'audio') {
        return {
          ...state,
          activeElements: []
        };
      }
      return state;
    }

    case DELETE_SELECTED_SCENES:
    case DELETE_MULTIPLE_ELEMENTS_BY_ID: {
      return {
        ...state,
        activeElements: []
      };
    }

    case SET_SHOW_ELEMENT_MODAL: {
      return {
        ...state,
        activeElements: []
      };
    }

    case CREATE_TEXT_ELEMENT: {
      return {
        ...state,
        activeElements: []
      };
    }

    case DUPLICATE_SCRIBE: {
      return {
        ...state,
        duplicatingScribe: true
      };
    }

    case DUPLICATE_SCRIBE_START: {
      return {
        ...state,
        loadingScribes: [action.loadingScribe, ...state.loadingScribes]
      };
    }

    case DUPLICATE_SCRIBE_SUCCESS: {
      return {
        ...state,
        duplicatingScribe: true,
        allScribes: [action.scribe, ...state.allScribes],
        loadingScribes: state.loadingScribes.filter(scribe => scribe.loadingId !== action.loadingId)
      };
    }

    case DUPLICATE_SCRIBE_FAILED: {
      return {
        ...state,
        duplicatingScribe: true,
        loadingScribes: state.loadingScribes.filter(scribe => scribe.loadingId !== action.loadingId)
      };
    }

    default:
      return state;
  }
}
